export const GET_TRANSACTION_REPORT = "GET_TRANSACTION_REPORT";
export const GET_SETTLEMENT_REPORT = "GET_SETTLEMENT_REPORT";
export const GET_COMMISSION_REPORT = "GET_COMMISSION_REPORT";
export const GET_AUDIT_REPORT = "GET_AUDIT_REPORT";
